import {h, Component, Prop, Host} from '@stencil/core'

@Component({
    styleUrl: 'chart-kpi.css',
    tag: 'chart-kpi',
    shadow: true
})
export class ChartKpi {
    @Prop() label: string;
    @Prop() value: string;

    render() {
        return (
            <Host class="chart-kpi-container">
                <unity-typography class='element' variant='data-display-four'>{this.value}</unity-typography>
                <unity-typography class='element' variant='caption-text'>{this.label}</unity-typography>
            </Host>
        )
    }
}